import { lazy } from "react";

const CHUNK_ERROR_PATTERN = /Loading chunk [\w-]+ failed|ChunkLoadError|Failed to fetch dynamically imported module/i;

function isChunkLoadError(error) {
  if (!error) return false;
  if (error.name === "ChunkLoadError") return true;
  return CHUNK_ERROR_PATTERN.test(String(error.message || ""));
}

/**
 * Wrap React.lazy() so stale deployments can recover after a chunk hash mismatch.
 */
export function lazyWithRetry(factory, { retries = 2, retryDelayMs = 800 } = {}) {
  return lazy(async () => {
    let lastError;
    for (let attempt = 0; attempt <= retries; attempt += 1) {
      try {
        return await factory();
      } catch (error) {
        lastError = error;
        if (!isChunkLoadError(error) || attempt === retries) {
          throw error;
        }
        await new Promise((resolve) => window.setTimeout(resolve, retryDelayMs * (attempt + 1)));
      }
    }
    throw lastError;
  });
}

export function lazyWithPreloadAndRetry(factory, options) {
  const Component = lazyWithRetry(factory, options);
  Component.preload = factory;
  return Component;
}
